import { __awaiter } from "tslib";
import { AEMScenes } from '@as-react/common-types';
const moduleCollection = {
    // @TODO: Remove Bootstrap after new auth deploy
    [AEMScenes.BOOTSTRAP]: () => import('./Bootstrap.rootModule'),
    [AEMScenes.BUY_PAYMENT_REQUEST]: () => import('./Buy.rootModule'),
    [AEMScenes.CHECKOUT_CONFIRMATION]: () => import('./CheckoutConfirmation.rootModule'),
    [AEMScenes.ACCOUNT_MENU_ITEM]: () => import('./AccountMenuItem.rootModule'),
    [AEMScenes.WISHLIST]: () => import('./WishlistLister.rootModule'),
    [AEMScenes.WISHLIST_MENU_ITEM]: () => import('./WishlistMenuItem.rootModule'),
    [AEMScenes.BASKET_MENU_ITEM]: () => import('./BasketMenuItem.rootModule'),
    [AEMScenes.SEARCH_MENU_ITEM]: () => import('./MenuSearch.rootModule'),
    [AEMScenes.PRODUCT_LISTER]: () => import('./ProductLister.rootModule'),
    [AEMScenes.PRODUCT_LISTER_DEPRECATED]: () => import('./ProductLister.rootModule'),
    [AEMScenes.PRODUCT_DETAIL_V2]: () => import('./productDetail.rootModule'),
    [AEMScenes.AUTHOR_LINKED_PRODUCTS]: () => import('./productGroup.rootModule'),
    [AEMScenes.PRODUCT_GROUP]: () => import('./productGroup.rootModule'),
    [AEMScenes.PRODUCT_RECENTLY_VIEWED]: () => import('./productRecentlyViewed.rootModule'),
    [AEMScenes.PRODUCT_GROUP_FREDHOPPER]: () => import('./ProductGroupFredhopper.rootModule'),
    [AEMScenes.PRODUCT_GROUP_MONETATE]: () => import('./ProductGroupMonetate.rootModule'),
    [AEMScenes.PRODUCT_GROUP_PDP_COMPARISON_FREDHOPPER]: () => import('./ProductGroupPdpComparisonFredhopper.rootModule'),
    [AEMScenes.PRODUCT_GROUP_PDP_COMPARISON_MONETATE]: () => import('./ProductGroupPdpComparisonMonetate.rootModule'),
    [AEMScenes.SINGLE_PRODUCT_TILE]: () => import('./SingleProductTile.rootModule'),
    [AEMScenes.PRODUCT_REVIEW]: () => import('./ProductReview.rootModule'),
    [AEMScenes.PRODUCT_COMPARISON]: () => import('./ProductComparison.rootModule'),
    [AEMScenes.GIFT_VOUCHER]: () => import('./GiftVoucher.rootModule'),
    [AEMScenes.DPE_ACTIVATOR]: () => import('./DpeActivator.rootModule'),
    [AEMScenes.BASKET_OVERVIEW_V2]: () => import('./BasketOverview.rootModule'),
    [AEMScenes.BASKET_PERSONAL_SHOPPING_ADVICE]: () => import('./BasketPersonalShoppingAdvice.rootModule'),
    [AEMScenes.ESSENTIALS]: () => import('./Essentials.rootModule'),
    [AEMScenes.GUEST_REDIRECT]: () => import('./GuestRedirect.rootModule'),
    [AEMScenes.SHOP_NUMBER]: () => import('./ShopNumber.rootModule'),
    [AEMScenes.COOKIE_MESSAGE]: () => import('./CookieMessage.rootModule'),
    [AEMScenes.PRODUCT_WIZARD]: () => import('./ProductWizard.rootModule'),
    [AEMScenes.BRAND_TILE_LISTER]: () => import('./BrandLister.rootModule'),
    [AEMScenes.CONTENT_TILE_LISTER]: () => import('./ContentTileLister.rootModule'),
    [AEMScenes.CAMPAIGN_GROUP]: () => import('./CampaignGroup.rootModule'),
    [AEMScenes.COLLAPSIBLE_LIST]: () => import('./CollapsibleList.rootModule'),
    [AEMScenes.PRODUCT_INSPIRATION]: () => import('./ProductInspiration.rootModule'),
    [AEMScenes.RETURN_ITEMS]: () => import('./ReturnItems.rootModule'),
    [AEMScenes.NEWSLETTER_SUBSCRIBE]: () => import('./NewsletterSubscribe.rootModule'),
    [AEMScenes.ORDER_OVERVIEW]: () => import('./OrderOverview.rootModule'),
    [AEMScenes.RETURN_PORTAL_LOGIN]: () => import('./ReturnPortalLogin.rootModule'),
    [AEMScenes.ACCOUNT_MENU]: () => import('./AccountMenu.rootModule'),
    [AEMScenes.SHOP_THE_LOOK]: () => import('./ShopTheLook.rootModule'),
    [AEMScenes.ACCOUNT_REGISTRATION]: () => import('./AccountRegistration.rootModule'),
    [AEMScenes.ACCOUNT_PAYBACK_ENRICHMENT]: () => import('./AccountPaybackEnrichment.rootModule'),
    [AEMScenes.ACCOUNT_PREFERENCES]: () => import('./AccountPreferences.rootModule'),
    [AEMScenes.ACCOUNT_DELIVERY_ADDRESSES]: () => import('./AccountDeliveryAddresses.rootModule'),
    [AEMScenes.ACCOUNT_PROFILE_DETAILS]: () => import('./AccountProfileDetails.rootModule'),
    [AEMScenes.ACCOUNT_ORDER_HISTORY]: () => import('./AccountOrderHistory.rootModule'),
    [AEMScenes.PRODUCT_CONTENT_VIDEO]: () => import('./ProductContentVideo.rootModule'),
    [AEMScenes.LOGIN]: () => import('./Login.rootModule'),
    [AEMScenes.REGISTRATION_COMPACT]: () => import('./RegistrationCompact.rootModule'),
    [AEMScenes.SLIDER]: () => import('./Slider.rootModule'),
    [AEMScenes.RENTAL]: () => import('./Rental.rootModule'),
    [AEMScenes.MONETATE]: () => import('./Monetate.rootModule'),
    [AEMScenes.REEVOO_CUSTOMER_EXPERIENCE]: () => import('./Reevoo.rootModule'),
    [AEMScenes.ETICKET]: () => import('./Eticket.rootModule'),
    [AEMScenes.SHOPPING_BUDGET]: () => import('./ShoppingBudget.rootModule'),
    [AEMScenes.DELIVERY_CONDITIONS_BANNER]: () => import('./DeliveryConditionsBanner.rootModule'),
    [AEMScenes.MOBILE_NAVIGATION]: () => import('./MobileNavigation.rootModule'),
    [AEMScenes.CHECKOUT]: () => import('./Checkout.rootModule'),
    [AEMScenes.RELATED_CATEGORIES]: () => import('./RelatedCategories.rootModule'),
    [AEMScenes.ACCOUNT_ENRICHMENT]: () => import('./AccountEnrichment.rootModule'),
    [AEMScenes.HEADER]: () => import('./Header.rootModule'),
};
export const loadFromModuleCollectionImplementation = (componentName, initialState) => __awaiter(void 0, void 0, void 0, function* () {
    const loadedDynamicModule = yield moduleCollection[componentName]();
    return loadedDynamicModule.default(initialState);
});
export const checkModuleCollectionForComponent = (componentName) => Object.keys(moduleCollection).indexOf(componentName) >= 0;
